import React from "react";

const Footer = () => (
  <footer
    style={{
      textAlign: "center",
      padding: "1rem",
      background: "#222",
      color: "#fff",
    }}
  >
    &copy; {new Date().getFullYear()} Rajo Mampionona Rakotoniaina.
  </footer>
);

export default Footer;
